import serviceCalls from "../services/serviceCalls";
import { toastr } from 'react-redux-toastr';

// const hash = [
// 	{
// 		"thumbnail": 'https://d310ox1f4zno4b.cloudfront.net/static-content/islam-in-black-america.jpg.webp',
// 		title: 'Islam In Blackamerica: From Slavery to Hip-Hop',
// 		description: 'An in-depth historical overview of Islam in BlackAmerica and the significance of that for all American Muslims today.',
// 		URL: 'https://www.bayanonline.org/products/islam-in-blackamerica-from-slavery-to-hip-hop',
// 	},
// 	{
// 		"thumbnail": 'https://d310ox1f4zno4b.cloudfront.net/static-content/foundation-of-islamic-studies.jpg.webp',
// 		title: 'Foundations of Islamic Studies',
// 		description: 'This course will feature introductions to three topics: the essentials of Islamic theology and creed, and will touch upon the modern epistemological and ontological frames and issues that challenge it; an intro to Islamic devotional law; and an overview of the foundations of Islamic ethics and the spiritual framework, with discussions around topics related to modern ethical issues. ',
// 		URL: "https://www.bayanonline.org/products/foundations-of-islamic-studies",
// 	},
// 	{
// 		"thumbnail": 'https://d310ox1f4zno4b.cloudfront.net/static-content/prophetic-biography.jpg.webp',
// 		title: 'Prophetic Biography ',
// 		description: 'An academic study of the modern issues surrounding the life of the Prophet Muhammad.',
// 		URL: "https://www.bayanonline.org/products/prophetic-biography",
// 	},
// 	{
// 		"thumbnail": 'https://d310ox1f4zno4b.cloudfront.net/static-content/foundation-of-an-islamic-paradigm.jpg.webp',
// 		title: 'Foundations of the Islamic Worldview',
// 		description: 'A survey of classical Islamic theology and how other branches of Islamic thought, from Islamic law to psychology, complemented the scope and content of how Muslims spoke of God and the world. ',
// 		URL: "https://www.bayanonline.org/products/foundations-of-the-islamic-worldview",
// 	},
// 	{
// 		"thumbnail": 'https://d310ox1f4zno4b.cloudfront.net/static-content/chaplaincy-in-contexts.jpg.webp',
// 		title: 'Chaplaincy in Contexts',
// 		description: 'An introduction to the theory, practices, and major issues of chaplaincy as a specialized form of spiritual care. The course is appropriate for those preparing for work in hospital, hospice, university, prison, and military chaplaincies. The arts and challenges of inter-religious and intercultural care are also addressed.',
// 		URL: "https://www.bayanonline.org/products/chaplaincy-in-contexts",
// 	},
// 	{
// 		"thumbnail": 'https://d310ox1f4zno4b.cloudfront.net/static-content/islamic-history.jpg.webp',
// 		title: 'Islamic History ',
// 		description: 'A survey of Islamic political history and the major issues throughout it, from the birth of the Prophet Muhammad, until modern times. ',
// 		URL: "https://www.bayanonline.org/products/islamic-history",
// 	},
// 	{
// 		"thumbnail": 'https://d310ox1f4zno4b.cloudfront.net/static-content/islamic-law-and-legal-theory.jpg.webp',
// 		title: 'Islamic Law and Legal Theory',
// 		description: 'An intermediary course on the foundations of Islamic law and legal thought, and focuses on the mechanisms of Islamic legal theory, how they were formulated, and their implications on modern Muslim issues today. ',
// 		URL: "https://www.bayanonline.org/products/islamic-law-and-legal-theory",
// 	},
// 	{
// 		"thumbnail": 'https://d310ox1f4zno4b.cloudfront.net/static-content/islam-in-america.jpg.webp',
// 		title: 'Islam in America',
// 		description: 'An in-depth discussion about the issues of state power, the media and popular culture, and how American Muslims must navigate these issues while maintaining their religious integrity. ',
// 		URL: "https://www.bayanonline.org/products/islam-in-america",
// 	},
// 	{
// 		"thumbnail": 'https://d310ox1f4zno4b.cloudfront.net/static-content/prophetic-model-of-ministry.jpg.webp',
// 		title: 'Prophetic Model of Ministry',
// 		description: 'A walkthrough of the best practices in Ministry for Imams, Chaplains, Activists, and anyone involved in community work. ',
// 		URL: "https://www.bayanonline.org/products/prophetic-model-of-ministry",
// 	},
// 	{
// 		"thumbnail": 'https://d310ox1f4zno4b.cloudfront.net/static-content/islamic-theology-and-philiosphy.jpg.webp',
// 		title: 'Islamic Theology & Philosophy',
// 		description: 'An in-depth look at the development of kalām theology and philosophy in the classical period (8-12th CE).',
// 		URL: "https://www.bayanonline.org/products/islamic-theology-philosophy",
// 	},
// 	{
// 		"thumbnail": 'https://d310ox1f4zno4b.cloudfront.net/static-content/universal-maxims.jpg.webp',
// 		title: 'Universal Maxims in Islamic Law & Beyond',
// 		description: 'An introduction to the discipline of Qawāʾid al-Kuliyyah & the Modern Ottoman Majjele project (1876) of Cevdet Pasha, the philosophical concept of ‘universals’ and the debate around it, the development & significance of ‘universal maxims’ in Islamic Studies, and an applied considerations of maxims enjoying a practical remit beyond the scope of jurisprudence proper.',
// 		URL: "https://www.bayanonline.org/products/universal-maxims-in-islamic-law-beyond",
// 	},
// 	{
// 		"thumbnail": 'https://d310ox1f4zno4b.cloudfront.net/static-content/islamic-mysticism.jpg.webp',
// 		title: 'Islamic Mysticism: The Literary & Cultural Dimensions',
// 		description: 'This course seeks to engage the mystical interpretations of Islam, primarily through the tradition of Rumi, as one of the most important historical manifestations of the Islamic experience. ',
// 		URL: "https://www.bayanonline.org/products/islamic-mysticism-the-literary-cultural-dimensions",
// 	},
// 	{
// 		"thumbnail": 'https://d310ox1f4zno4b.cloudfront.net/static-content/self-development-and-spiritual-care.jpg.webp',
// 		title: 'Self-Development & Spiritual Care',
// 		description: 'This course provides an opportunity to explore and cultivate practices for self-assessment, self-renewal and development, and self-care for religious and spiritual leadership.',
// 		URL: "https://www.bayanonline.org/products/self-development-spiritual-care",
// 	},
// 	{
// 		"thumbnail": 'https://d310ox1f4zno4b.cloudfront.net/static-content/islam-and-liberal-citizenship.jpg.webp',
// 		title: 'Islam & Liberal Citizenship',
// 		description: 'The course explores political liberalism and its relationship to religion, particularly Islam and its intellectual heritage. Topics include secularization, religious critics of political liberalism, multiculturalism, and forms of constitutional law pertaining to religious freedom. Pre-modern theories of Islamic government, and modern Islamic political thought, will be engaged. Within this framework, students will reflect onhow faith can, does and should work in connection with our personal, social and political freedoms.',
// 		URL: "https://www.bayanonline.org/products/islam-liberal-citizenship",
// 	},
// 	{
// 		"thumbnail": 'https://d310ox1f4zno4b.cloudfront.net/static-content/fundraising-strategies.jpg.webp',
// 		title: 'Fundraising Strategies for Religious Non-Profits',
// 		description: 'This course is designed for current or aspiring managers, professional staff, and volunteers in the nonprofit sector who want to become familiar with the fundamentals of philanthropy and fundraising specifically focused on faith- based organizations and religiously motivated donors.',
// 		URL: "https://www.bayanonline.org/products/fundraising-strategies-for-religious-non-profits",
// 	},
// 	{
// 		"thumbnail": 'https://d310ox1f4zno4b.cloudfront.net/static-content/islamic-bioethics.jpg.webp',
// 		title: 'Islamic Bioethics',
// 		description: 'This course introduces learners to critical concepts in Islamic theology, law, and ethics that undergird normative ethical frameworks, while also exposing the student to applied works within the Islamic bioethics literature and explore the emerging field by considering research methods for the field, spiritual care provision and ethical boundaries, and reviews of pressing bioethics topics.',
// 		URL: "https://www.bayanonline.org/products/islamic-bioethics",
// 	},
// 	{
// 		"thumbnail": 'https://d310ox1f4zno4b.cloudfront.net/static-content/islam-and-west-africa.jpeg',
// 		title: 'Islam & West Africa',
// 		description: 'This short seminar series looks at some preliminary concepts and frameworks into the subject of Islam & West Africa.',
// 		URL: "https://www.bayanonline.org/products/islam-west-africa",
// 	},
// 	{
// 		"thumbnail": 'https://d310ox1f4zno4b.cloudfront.net/static-content/public-speaking.jpg.webp',
// 		title: 'Public Speaking: Islam & The Media',
// 		description: 'This is a public speaking course with a focus on media training and crafting an authentic internal narrative. In this course, Professor Mehdi Hasan highlights important concepts, tools, and best practices in discussing Islam to the media. This course is intended to train regional and national leadership in English speaking countries on how to best present Islam to a global audience. ',
// 		URL: "https://www.bayanonline.org/products/public-speaking-islam-the-media",
// 	},
// ]

export const fetchClasses = async () => {
    try {
        const result = await serviceCalls.get('/api/courses', {}, true);
        if (result?.status == 422 || result?.status == "error" || result?.data?.status == "error") {
            toastr.error("Sorry", result?.data || result?.data?.error || "Something went wrong!");
            throw new Error('Something went wrong');
        } else {
            return result;
        }
    } catch (e) {
        return [];
    }
}

export const getOneCourse = async (id) => {
    try {
        const result = await serviceCalls.get(`/api/get_course?slug=${id}`, {}, true);
        if (result?.status == 422 || result?.status == "error" || result?.data?.status == "error") {
            toastr.error("Sorry", result?.data || result?.data?.error || "Something went wrong!");
            throw new Error('Something went wrong');
        } else {
            return result;
        }
    } catch (e) {
        return {};
    }
}
